import { HIDDEN_POSITION, TooltipPositions } from './tooltipConstants';

export const getArrowPosition = (
    targetRect: DOMRect,
    arrowRect: DOMRect,
    options: {
        position: TooltipPositions;
        distance: number;
    },
) => {
    const { position, distance = 0 } = options;
    switch (position) {
        case TooltipPositions.TOP:
            return {
                left: targetRect.left + (targetRect.width - arrowRect.width) / 2,
                top: targetRect.top - arrowRect.height - distance,
            };
        case TooltipPositions.BOTTOM:
            return {
                left: targetRect.left + (targetRect.width - arrowRect.width) / 2,
                top: targetRect.bottom + distance,
            };
        case TooltipPositions.LEFT:
            return {
                left: targetRect.left - arrowRect.width - distance,
                top: targetRect.top + (targetRect.height - arrowRect.height) / 2,
            };
        case TooltipPositions.RIGHT:
            return {
                left: targetRect.right + distance,
                top: targetRect.top + (targetRect.height - arrowRect.height) / 2,
            };
        default:
            return HIDDEN_POSITION;
    }
};
